import React from 'react';
import Modal from '../shared/Modal';
import Formsy from 'formsy-react';
import Checkbox from '../form/FormsyCheckbox';

class DishAddSubcomponentModal extends React.PureComponent {
  state = {
    selectedItems: []
  };

  render() {
    const { isOpen, closeModal, ingredients } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding admin-wrapper"
      >
        <div className="modal__head">
          <h2 className="h2 modal__heading">Select Ingredient(s)</h2>
          <p className="p">
            Which ingredient(s) would you like to add instructions to?
          </p>

          <Formsy className="row">{this.renderCheckboxes(ingredients)}</Formsy>

          <div className="row">
            <div className="row__item row__item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="row__item row__item--half">
              <div
                className="btn btn--solid-blue btn--full-width"
                onClick={this.createSubcomponent}
              >
                Group
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderCheckboxes(items = []) {
    if (items.length === 0) return;

    const { isChecked, toggleChecked } = this;
    return items.map((item, key) => (
      <div key={key} className="row__item row__item--half">
        <Checkbox
          name={`ingredient_${key}`}
          className="checkbox--large checkbox--flex form__row-item--third"
          placeholder={item.friendly_name}
          checked={isChecked(key)}
          onChange={e => toggleChecked(key)}
        />
      </div>
    ));
  }

  isChecked = value => {
    return this.state.selectedItems.includes(value);
  };

  toggleChecked = key => {
    let selectedItems = [...this.state.selectedItems];

    if (this.isChecked(key)) {
      // delete
      const index = selectedItems.findIndex(val => val === key);
      selectedItems = [
        ...selectedItems.slice(0, index),
        ...selectedItems.slice(index + 1, selectedItems.length)
      ];
    }
    // add
    else selectedItems.push(key);

    this.setState({ selectedItems });
  };

  createSubcomponent = () => {
    this.props.addSubcomponent(this.state.selectedItems);
    this.setState({ selectedItems: [] });
  };
}

export default DishAddSubcomponentModal;



// WEBPACK FOOTER //
// ./src/components/dish/DishAddSubcomponentModal.js